var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"column carousel-slider-container pay-parking"},[_c('ItemMenuSlider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }